import React from 'react'
import styled from 'styled-components'
import {WINDOW_MODE_TABLET_WIDTH} from 'consts'
import {useTranslation} from 'i18n'
import {InputArea} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopUploadContentFormProps} from './GiftShopUploadContentFormProps'

const StyledDescription = styled.div`
  margin-left: ${convertUnit(25)};
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    margin-top: ${convertUnit(0)};
    margin-left: ${convertUnit(0)};
  }
`

export default function GiftShopUploadContentDescriptionForm({
  form,
}: GiftShopUploadContentFormProps) {
  const {translate} = useTranslation()
  const {watch} = form
  const {description} = watch()

  return (
    <StyledDescription>
      <InputArea
        name="description"
        form={form}
        defaultValue={description}
        label={translate('giftShop:uploadDescriptionLabel')}
        placeholder={translate('giftShop:uploadInputDescriptionPlaceholder')}
        autoComplete={false}
        containerStyle={{
          marginTop: convertUnit(25),
        }}
        contentContainerStyle={{height: '100%'}}
        inputContainerStyle={{height: convertUnit(69)}}
      />
    </StyledDescription>
  )
}
